/**
 * Input-mask helpers for this screen's `TextField` `format` props. They run on
 * every keystroke / paste and reject anything that doesn't fit the mask, so the
 * numeric `inputMode` / `keyboardType` hints (which only affect mobile soft
 * keyboards) are backed up on web and hardware-keyboard input.
 *
 * Defined here rather than shared: each screen module owns the masks it uses, so
 * nothing in a published module graph has to reach across into another module's
 * internals for them. They are one-liners; a copy is cheaper than the coupling.
 */

/** US ZIP code: up to 5 digits. Long format (00000-0000) is a future extension. */
export const formatZipCode = (raw: string): string => raw.replace(/\D/g, '').slice(0, 5);
